import Box from '@mui/material/Box/Box'
import Stack from '@mui/material/Stack/Stack'
import Typography from '@mui/material/Typography/Typography'
import { ServiceTypeAvatar } from 'components-ui/src/icon_avatar/icon_avatar'

import { WaitlistOrderClientDto } from 'service-api/src/types/api'

interface Props {
  order: WaitlistOrderClientDto
  displayName?: string
  renderAvatar?: boolean
}

interface TDuplicateServiceTypeMarkerProps {
  serviceTypeName?: string | null
}

const serviceTypeColors: Record<string, string> = {
  daycare: 'warning.main',
  boarding: 'primary.dark',
  training: 'primary.main',
}

const DuplicateServiceTypeMarker = (props: TDuplicateServiceTypeMarkerProps) => {
  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Box
        data-testid="service-type-marker-dot"
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: serviceTypeColors[props.serviceTypeName || ''] || 'primary.main',
        }}
      />
    </Box>
  )
}

export const ServiceType = ({ order, displayName, renderAvatar = true }: Props) => {
  const primarySt = order.primaryServiceType?.serviceType?.name
  if (!primarySt || displayName === undefined) return null

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      {renderAvatar ? (
        <ServiceTypeAvatar fontSize="small" size="small" serviceType={primarySt} />
      ) : (
        <DuplicateServiceTypeMarker serviceTypeName={primarySt} />
      )}
      <Typography variant="body2bold">{displayName}</Typography>
    </Stack>
  )
}
